import React from "react"

import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

import PageSection from "../../pageSection/pageSection.js"
import H2 from "../../h2/h2.js"
import H3 from "../../h3/h3.js"
import P from "../../p/p.js"

import styles from "./tillEffect.module.scss"

const TillEffectSection = () => {
  const data = useStaticQuery(graphql`
    query {
      familyIllustration: file(relativePath: { eq: "home/family-illustration.png" }) {
        childImageSharp {
          gatsbyImageData (
            width: 1000
            placeholder: BLURRED
            formats: [AUTO, WEBP, AVIF]
          )
        }
      }
      forKidsPaying: file(relativePath: { eq: "home/for-kids-paying.png" }) {
        childImageSharp {
          gatsbyImageData (
            width: 333
            placeholder: BLURRED
            formats: [AUTO, WEBP, AVIF]
          )
        }
      }
      forKidsGirls: file(relativePath: { eq: "home/for-kids-girls.png" }) {
        childImageSharp {
          gatsbyImageData (
            width: 333
            placeholder: BLURRED
            formats: [AUTO, WEBP, AVIF]
          )
        }
      }
      forKidsKids: file(relativePath: { eq: "home/for-kids-kids.png" }) {
        childImageSharp {
          gatsbyImageData (
            width: 333
            placeholder: BLURRED
            formats: [AUTO, WEBP, AVIF]
          )
        }
      }
      forParentsDadSon: file(relativePath: { eq: "home/for-parents-dad-son.png" }) {
        childImageSharp {
          gatsbyImageData (
            width: 333
            placeholder: BLURRED
            formats: [AUTO, WEBP, AVIF]
          )
        }
      }
      forParentsPeople: file(relativePath: { eq: "home/for-parents-people.png" }) {
        childImageSharp {
          gatsbyImageData (
            width: 333
            placeholder: BLURRED
            formats: [AUTO, WEBP, AVIF]
          )
        }
      }
      forParentsPhone: file(relativePath: { eq: "home/for-parents-phone.png" }) {
        childImageSharp {
          gatsbyImageData (
            width: 333
            placeholder: BLURRED
            formats: [AUTO, WEBP, AVIF]
          )
        }
      }
      confettiLeft: file(relativePath: { eq: "home/till-effect-confetti-left.png" }) {
        childImageSharp {
          gatsbyImageData (
            width: 180
            placeholder: BLURRED
            formats: [AUTO, WEBP, AVIF]
          )
        }
      }
      confettiRight: file(relativePath: { eq: "home/till-effect-confetti-right.png" }) {
        childImageSharp {
          gatsbyImageData (
            width: 180
            placeholder: BLURRED
            formats: [AUTO, WEBP, AVIF]
          )
        }
      }
    }
  `)

  return (
    <PageSection
      backgroundColor="#ffffff"
      LeftComponent={() =>
        <div className={styles.confettiLeft}>
          <GatsbyImage
            image={getImage(data.confettiLeft)}
            alt="Colorful Till confetti"
            width={180}
          />
        </div>
      }
      RightComponent={() =>
        <div className={styles.confettiRight}>
          <GatsbyImage
            image={getImage(data.confettiRight)}
            alt="Colorful Till confetti"
            width={180}
          />
        </div>
      }
    >
      <div className={styles.root}>
        <div className={styles.headingContainer}>
          <H2 slideUp>The Till Effect</H2>
          <div className={styles.yellowBar} />
          <P className={styles.p}>We’ve seen it time and again. When you treat kids with respect and put the decisions in their hands, they rise to the occasion. For countless Till users, we see the same results.</P>
        </div>

        <GatsbyImage
          image={getImage(data.familyIllustration)}
          alt="Illustrated image of a teenager using their phone to manage money, with their two parents by their side"
          width={1000}
        />

        <div style={{ width: "100%", maxWidth: 1000, marginTop: 50 }}>
          <div className={styles.valueProps}>
            <H3 className={styles.h3}>For Kids</H3>
            <div className={styles.valuePropRow}>
              <div className={styles.valuePropItem}>
                <GatsbyImage
                  image={getImage(data.forKidsPaying)}
                  alt="Hand of a kid paying for a sticky bun and a hot chocolate with their Till debit card"
                  width={200}
                />
                <P className={styles.valuePropCopy}>The independence to spend on their own</P>
              </div>
              <div className={styles.valuePropItem}>
                <GatsbyImage
                  image={getImage(data.forKidsGirls)}
                  alt="Two girls holding their phones showing the home screen of the Till app"
                  width={200}
                />
                <P className={styles.valuePropCopy}>The pride of “I bought it with my own money”</P>
              </div>
              <div className={styles.valuePropItem}>
                <GatsbyImage
                  image={getImage(data.forKidsKids)}
                  alt="Group of four kids looking at the Till App on one of the kid's phones"
                  width={200}
                />
                <P className={styles.valuePropCopy}>The security of not losing money. It’s safe in one spot.</P>
              </div>
            </div>
          </div>
        </div>

        <div style={{ width: "100%", maxWidth: 1000, marginTop: 50 }}>
          <div className={styles.valueProps}>
            <H3 className={styles.h3}>For Parents</H3>
            <div className={styles.valuePropRow}>
              <div className={styles.valuePropItem}>
                <GatsbyImage
                  image={getImage(data.forParentsDadSon)}
                  alt="Father showing his son how to use the Till app on his phone"
                  width={200}
                />
                <P className={styles.valuePropCopy}>The pride of helping kids be more self-sufficient</P>
              </div>
              <div className={styles.valuePropItem}>
                <GatsbyImage
                  image={getImage(data.forParentsPeople)}
                  alt="Parent holding a phone and a Till debit card with her two daughters by her side"
                  width={200}
                />
                <P className={styles.valuePropCopy}>Take the stress out of family conversations about money</P>
              </div>
              <div className={styles.valuePropItem}>
                <GatsbyImage
                  image={getImage(data.forParentsPhone)}
                  alt="Pair of hands holding a phone with the Till app opened, showing the financial summary of a family"
                  width={200}
                />
                <P className={styles.valuePropCopy}>Peace of mind from seeing their spending</P>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageSection>
  )
}

export { TillEffectSection }
